module.exports = {
	"ff_all_asset": 41007794205,
	"oil_majors": [
		8267147696,
		0.20159942411611118,
		[
			[
				"Exxon Mobil",
				3042722478
			],
			[
				"Chevron",
				1902435055
			],
			[
				"Shell",
				876273650
			],
			[
				"ConocoPhillips",
				771750406
			],
			[
				"TotalEnergies",
				519494758
			],
			[
				"BP",
				376693855
			],
			[
				"Phillips 66",
				336228412
			],
			[
				"Valero Energy",
				294100713
			],
			[
				"Eni",
				147448369
			]
		]
	],
	"og": [
		16388329751,
		0.3996393873094935,
		[
			[
				"Exxon Mobil",
				3042722478
			],
			[
				"Chevron",
				1902435055
			],
			[
				"Shell",
				876273650
			],
			[
				"ConocoPhillips",
				771750406
			],
			[
				"Cheniere Energy",
				710025237
			],
			[
				"TotalEnergies",
				519494758
			],
			[
				"Williams Companies",
				436540536
			],
			[
				"EOG Resources",
				420811661
			],
			[
				"BP",
				376693855
			],
			[
				"SLB",
				341498801
			]
		]
	],
	"ut": [
		10904834975,
		0.26592103248680454,
		[
			[
				"NextEra Energy",
				916175760
			],
			[
				"Southern",
				626612963
			],
			[
				"Constellation Energy",
				596229477
			],
			[
				"Duke Energy",
				588093276
			],
			[
				"Vistra",
				396137466
			],
			[
				"American Electric Power",
				366306912
			],
			[
				"Sempra",
				332569680
			],
			[
				"Dominion Energy",
				315507222
			],
			[
				"Enel",
				303274648
			],
			[
				"National Grid",
				277812172
			]
		]
	],
	"other": [
		13714629479,
		0.33443958020370196,
		[
			[
				"Berkshire Hathaway",
				5697025851
			],
			[
				"GE Vernova",
				1033376786
			],
			[
				"Siemens",
				850449693
			],
			[
				"Blackstone",
				772501685
			],
			[
				"KKR",
				583251605
			],
			[
				"BHP Group",
				579779342
			],
			[
				"Ares Management",
				509005711
			],
			[
				"CSX",
				377252643
			],
			[
				"Mitsubishi Heavy Indus",
				331017220
			],
			[
				"Mitsubishi",
				297020275
			]
		]
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data/TspHoldingStats.json
// module id = 1014
// module chunks = 0